var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      attrs: {
        id: "dropdown_shortcut",
        variant: "outline-success",
        text: "Dropdown Button",
        "no-caret": "",
      },
      scopedSlots: _vm._u([
        {
          key: "button-content",
          fn: function () {
            return [
              _c(
                "a",
                {
                  staticClass: "header-icon",
                  attrs: {
                    href: "#",
                    "data-toggle": "dropdown",
                    title: "My Apps",
                  },
                },
                [_c("i", { staticClass: "fal fa-cube" })]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("b-dropdown-form", { staticClass: "notif_user" }, [
        _c("div", { staticClass: "w-auto h-auto" }, [
          _c(
            "div",
            {
              staticClass:
                "dropdown-header bg-trans-gradient d-flex justify-content-center align-items-center rounded-top",
            },
            [
              _c("h4", { staticClass: "m-0 text-center color-white" }, [
                _vm._v(
                  "\n                    Quick Shortcut\n                    "
                ),
                _c("small", { staticClass: "mb-0 opacity-80" }, [
                  _vm._v("User Applications & Addons"),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }